import React, {useState} from "react";
import {Popover, List, ListItemButton, Box, Typography, CircularProgress} from "@mui/material";
import {CxIconButtonSecondary} from "./CxButton";

// --------------------------------------------------------------------------------------------------------------------
// CxPopover
// --------------------------------------------------------------------------------------------------------------------

const sxRow = { display: "grid", gap: 3, alignItems: "center", width: "100%" };

const sxHeaderCell = { fontWeight: 600, color: "text.secondary" };

export function CxPopover({ label, iconName,
                            data=[], columns=[], render=[], onSelect, onOpen,
                            loading = false, minWidth = 100, readOnly = false }) {

    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
        // if an onOpen callback function (to load data) is provided, call it now:
        if (onOpen) {
            onOpen();
        }
    }

    const handleClose = () => setAnchorEl(null);

    const handleSelect = (row) => {
        handleClose();
        if (onSelect) onSelect(row);
    };

    // Build grid columns dynamically
    const gridTemplateColumns = columns
        .map((col) => col.width || "1fr")
        .join(" ");

    //
    // render
    //
    return (
        <>
            <CxIconButtonSecondary
                label={label}
                iconName={iconName}
                disabled={readOnly || loading}
                onClick={handleOpen}
            />

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                {/* 1. Loading State */}
                {loading && (
                    <Box sx={{ p: 1 }}>
                        <CircularProgress size={18} />
                    </Box>
                )}

                {/* 2. Empty State */}
                {!loading && data.length === 0 && (
                    <Typography sx={{ p: 2 }} color="text.secondary">
                        Keine Favoriten vorhanden.
                    </Typography>
                )}

                {/* 3. Data List (Content) */}
                {!loading && data.length > 0 && (
                    <List sx={{ minWidth }}>
                        {/* Header */}
                        <Box
                            sx={{
                                ...sxRow,
                                gridTemplateColumns,
                                px: 2,
                                py: 1
                            }}
                        >
                            {columns.map((col) => (
                                <Typography key={col.field} sx={sxHeaderCell}>
                                    {col.label}
                                </Typography>
                            ))}
                        </Box>

                        {/* Rows */}
                        {data.map((row, index) => (
                            <ListItemButton
                                key={row.id || index}
                                onClick={() => handleSelect(row)}
                                disableRipple
                            >
                                <Box sx={{ ...sxRow, gridTemplateColumns }}>
                                    {columns.map((col) => {
                                        const value = row[col.field];
                                        const customRender = render[col.field];

                                        return (
                                            <Typography key={col.field} noWrap>
                                                {customRender
                                                    ? customRender(value, row)
                                                    : value}
                                            </Typography>
                                        );
                                    })}
                                </Box>
                            </ListItemButton>
                        ))}
                    </List>
                )}
            </Popover>
        </>
    );
}